import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { MockupSlot } from './MockupSlot';
import { babyShowerCheckoutUrl } from '../../data/config';
import { bonusesTotal, bundleDiscountPercent, bundleReferenceValue, formatArs, pricing, pricingFlags } from '../../data/babyShowerPricing';
import { offerExtraBonuses, offerIncludedItems, offerMockupImage } from '../../data/babyShowerOffer';
const offerCopy = {
  eyebrow: 'Baby Shower Dulce Recuerdo',
  title: '¡Tené resuelta la diversión de tu Baby Shower y lucite organizando!',
  subtitle: 'Ya preparamos los juegos para vos: llevate 30 imprimibles y recibí 50 dinámicas de regalo para que tus amigas y tu familia se diviertan y vos también disfrutes.',
  packSummary: '30 juegos imprimibles + 4 bonos incluidos',
  priceLead: 'Precio final del pack',
  priceNote: 'Pago único · Acceso digital',
  bonusLine: '¡Y te llevás los 4 bonos sin pagar extra!',
  cta: 'Quiero mi kit completo →'
};
const ctaClass = 'flex w-full items-center justify-center rounded-full bg-gradient-to-r from-[#E74D7A] to-[#EC6A92] px-6 py-4 text-center font-display text-[17px] font-extrabold uppercase leading-snug tracking-tight text-white shadow-[0_14px_30px_-12px_rgba(231,77,122,0.65)] transition-transform duration-150 ease-out hover:scale-[1.01] hover:from-[#DE3F6E] hover:to-[#E74D7A] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E74D7A] focus-visible:ring-offset-2 active:scale-[0.98] sm:py-5 sm:text-xl';
export function PricingOffer() {
  const items = [...offerIncludedItems, ...offerExtraBonuses.map(b => ({
    label: b.label,
    isBonus: true
  }))];
  return <section id="ajanlat" aria-labelledby="offer-title" className="scroll-mt-16 bg-[#FBF6EE] py-11 md:py-16" data-id="element-273" data-mp="3qgnx8zce5zlo">
      <div className="mx-auto max-w-xl px-5" data-id="element-274" data-mp="3lje9do4nhvzy">
        <header className="text-center" data-id="element-275" data-mp="3czw7re7hq2m">
          <p className="inline-flex max-w-full items-center rounded-full border border-[#EADFCF] bg-white px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.08em] text-[#8B6B55] sm:text-[12px]" data-id="element-276" data-mp="3e2oo3r6g0kn">
            {offerCopy.eyebrow}
          </p>
          <h2 id="offer-title" className="mx-auto mt-4 max-w-[24ch] font-display text-[1.6rem] font-extrabold leading-[1.15] tracking-[-0.02em] text-[#4A3A35] [text-wrap:balance] sm:text-[2rem]" data-id="element-277" data-mp="bdyy719f1it4">
            {offerCopy.title}
          </h2>
          <p className="mx-auto mt-3 max-w-md text-[16px] leading-relaxed text-body" data-id="element-278" data-mp="l4k3t8nibnlj">{offerCopy.subtitle}</p>
        </header>

        <div className="mt-7 rounded-[2rem] border border-[#EFE4D6] bg-white p-3 shadow-[0_24px_50px_-30px_rgba(139,107,85,0.55)] sm:p-4" data-id="element-279" data-mp="p53wo011s51v">
          <MockupSlot src={offerMockupImage} alt="Pack completo Baby Shower Dulce Recuerdo" slot="offer-mockup" label="Pack completo: 30 juegos imprimibles + bono de 50 dinámicas" tone="pink" data-id="element-280" data-mp="z3t9vfi011bs" />

          <div className="px-2 pb-3 pt-5 sm:px-4 sm:pb-4" data-id="element-281" data-mp="30v6bnvoo6t3m">
            <p className="mb-4 text-center font-display text-[17px] font-extrabold leading-snug text-[#4A3A35] sm:text-[18px]" data-id="element-282" data-mp="30wr4ngvc63zd">
              {offerCopy.packSummary}
            </p>
            <ul className="space-y-2.5" data-id="element-283" data-mp="1mzoeyxfzbfv3">
              {items.map(item => <li key={item.label} className="flex items-start gap-3 text-[15px] leading-snug text-[#4A3A35] sm:text-[16px]" data-id="element-284" data-mp="1i7mxmx3yeyy7">
                  <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${item.isBonus ? 'bg-[#DDF2F1] text-[#15ADA8]' : 'bg-[#FDE3EC] text-[#E74D7A]'}`} aria-hidden="true" data-id="element-285" data-mp="1e7cstnrweekx">
                    {item.isBonus ? <GiftIcon className="h-3 w-3" strokeWidth={2.5} data-id="element-286" data-mp="25wy0ck4v73ez" /> : <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-287" data-mp="21vw0q271cpch" />}
                  </span>
                  <span data-id="element-288" data-mp="1wwjd3f8cbe8u">
                    {item.isBonus && <span className="mr-1.5 inline-block rounded-full bg-[#C4E8E6] px-2 py-0.5 align-[1px] text-[11px] font-extrabold uppercase tracking-[0.06em] text-[#0E7C78]" data-id="element-289" data-mp="1wvhtgmd9djfi">
                        Hoy gratis
                      </span>}
                    {item.label}
                  </span>
                </li>)}
            </ul>

            <p className="mt-4 rounded-xl bg-[#DDF2F1] px-3 py-2 text-center text-[15px] font-bold text-[#0E7C78]" data-id="element-290" data-mp="24fikheltbz5i">
              {offerCopy.bonusLine}
            </p>

            <div className="mt-5 border-t border-dashed border-[#EADFCF] pt-5 text-center" data-id="element-291" data-mp="297ikt85sou2m">
              {pricingFlags.showBundleReferenceValue && <div className="mx-auto max-w-sm rounded-2xl bg-[#FAF0E7] px-4 py-3 text-[14px] text-body" style={{
              paddingTop: "0px"
            }} data-id="element-292" data-mp="20dnmaiz6i1vy">
                  
                  
                  <div className="mt-2 flex items-center justify-between gap-3 border-t border-[#EADFCF] pt-2 font-bold text-[#4A3A35]" data-id="element-293" data-mp="2s4tjaqjlrjh0">
                    <span data-id="element-294" data-mp="2e4iojcf69kqk">Valor total</span>
                    <span className="flex items-center gap-2" data-id="element-295" data-mp="2j4etpezlvi7p">
                      <s className="decoration-[#E74D7A] decoration-2" data-id="element-296" data-mp="2j2tydn5gvv8s">{formatArs(bundleReferenceValue)}</s>
                      {pricingFlags.showDiscountBadge && <span className="rounded-full bg-[#15ADA8] px-2 py-0.5 text-[11px] font-extrabold uppercase tracking-[0.04em] text-white" data-id="element-297" data-mp="17oyjmfih5oi3">
                          {bundleDiscountPercent}% off
                        </span>}
                    </span>
                  </div>
                </div>}
              <p className="mt-3 text-[15px] font-semibold text-body" data-id="element-298" data-mp="1965brq75imv9">{offerCopy.priceLead}</p>
              <p className="mt-1 font-display text-[3rem] font-extrabold leading-none tracking-[-0.03em] text-[#4A3A35] sm:text-[3.5rem]" data-id="element-299" data-mp="147arejtjcq91">
                {formatArs(pricing.offerPrice)} <span className="text-[1.25rem] tracking-normal" data-id="element-300" data-mp="gfnamupzmvkh">ARS</span>
              </p>
              <p className="mt-2.5 text-[14px] font-medium text-body" data-id="element-301" data-mp="chz9vb1m68ko">{offerCopy.priceNote}</p>

            </div>

            <div className="mt-5" data-id="element-302" data-mp="q9dv7oizuluw">
              {babyShowerCheckoutUrl ? <a href={babyShowerCheckoutUrl} data-checkout="ready" className={ctaClass} data-id="element-303" data-mp="lg185ityqn49">
                  {offerCopy.cta}
                </a> : <button type="button" data-checkout="pending" className={ctaClass} data-id="element-304" data-mp="3tujixsbaggrk">
                  {offerCopy.cta}
                </button>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}